import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import TextEditor from "../../../components/TextEditor";

export default function ReportEditorModal({
    isOpen,
    onClose,
    onChange,
    onEditorChange,
    onSubmit,
    values,
    loading,
    errors = {},
}) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 px-4">
            <div className="max-h-[88vh] w-full max-w-4xl overflow-hidden rounded-[28px] bg-white shadow-xl dark:bg-slate-950">
                <div className="flex items-center justify-between border-b border-slate-200 px-5 py-4 dark:border-slate-800">
                    <h3 className="text-base font-semibold text-slate-900 dark:text-slate-100">
                        {values.id ? "Editar informe" : "Generar nuevo informe"}
                    </h3>
                    <button
                        type="button"
                        onClick={onClose}
                        className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"
                    >
                        <XMarkIcon className="h-6 w-6" />
                    </button>
                </div>

                <form
                    onSubmit={onSubmit}
                    className="max-h-[calc(88vh-72px)] overflow-y-auto px-5 py-5"
                >
                    <div className="space-y-5">
                        <div>
                            <label className="block text-sm font-medium text-slate-700 dark:text-slate-200">
                                Titulo
                                <span className="ml-2 text-[#F51515]">*</span>
                            </label>
                            <input
                                type="text"
                                name="title"
                                value={values.title}
                                onChange={onChange}
                                className={`mt-1 block min-h-[44px] w-full rounded-xl border px-3 py-2 shadow-sm focus:border-primary focus:ring-primary dark:bg-slate-950 dark:text-slate-100 ${
                                    errors.title
                                        ? "border-red-500 dark:border-red-500"
                                        : "border-slate-300 dark:border-slate-700"
                                }`}
                            />
                            {errors.title && (
                                <p className="mt-1 text-sm text-red-500">
                                    {errors.title}
                                </p>
                            )}
                        </div>

                        <div>
                            <TextEditor
                                name="conclusion"
                                label="Conclusion"
                                value={values.conclusion}
                                handleChange={onEditorChange}
                                height={220}
                                containerClassName="pb-10"
                            />
                            {errors.conclusion && (
                                <p className="mt-1 text-sm text-red-500">
                                    {errors.conclusion}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className="mt-5 grid grid-cols-1 gap-3 border-t border-slate-200 pt-4 dark:border-slate-800 sm:grid-cols-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="inline-flex min-h-[44px] items-center justify-center rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="inline-flex min-h-[44px] items-center justify-center rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-white disabled:cursor-wait"
                            disabled={loading}
                        >
                            {loading ? "Guardando..." : "Guardar informe"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
